<template>
	<div class="control-panel-container">
		<div class="header row">
			<div class="col">
				<h1>IST - Facilitator Kontrolpanel</h1>
			</div>
		</div>

		<div class="current-quiz-row row mb-3">
			<div class="current-poll-type mr-3" v-if="currentPollTypeText && !ended">
				{{ currentPollTypeText }}
			</div>

			{{ currentPollTitle }}
		</div>

		<div v-if="loading" class="loading row">
			<strong>Henter data..</strong>
		</div>
		<div v-if="ended" class="loading row">
			<strong>Konkurrencen er nu afsluttet.</strong>
		</div>
		<div v-else class="row">
			<div class="container">
				<div class="row">

				</div>
				<div class="row">
					<div class="col-6">
						<div class="row mb-3" v-for="(row, key) in infoRows" :key="key">
							<div v-if="!row" class="col">
								<div class="mb-3"></div>
							</div>

							<div class="col" v-if="row">
								{{ row.label }}:
							</div>
							<div class="col text-right info-value" v-if="row">
								{{ row.value !== null ? row.value : '-' }}
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="row">
							<div class="col-6">
								<div>
									<strong>Visualisering af data</strong>
								</div>
								<div>
									<button class="btn btn-block btn-enable-visualisation" :class="visualisationEnabled ? 'btn-primary' : 'btn-outline-primary'" v-on:click="toggleVisualisationEnabled" :disabled="!canToggleVisualisation">Vis visualisering (slået <span v-text="visualisationEnabled ? 'til' : 'fra'"></span>)</button>
								</div>
								<div class="mt-3">
									<strong>Visualiserings type</strong>
								</div>
								<div>
									<button class="btn btn-block" :class="visualisationType === 'area' ? 'btn-dark' : 'btn-outline-dark'" :disabled="!canChangeVisualisation" v-on:click="setVisualisationType('area')">Landsdel</button>
								</div>
								<div>
									<button class="btn btn-block mt-3" :class="visualisationType === 'chart' ? 'btn-dark' : 'btn-outline-dark'" :disabled="!canChangeVisualisation" v-on:click="setVisualisationType('chart')">Søjler</button>
								</div>
								<div>
									<button class="btn btn-block mt-3" :class="visualisationType === 'classStep' ? 'btn-dark' : 'btn-outline-dark'" :disabled="!canChangeVisualisation" v-on:click="setVisualisationType('classStep')">Søjler, klassetrin</button>
								</div>
								<div class="mt-3">
									<strong>Export</strong>
								</div>
								<div>
									<button class="btn btn-block bmt-3" :class="canExport ? 'btn-dark' : 'btn-outline-dark'" :disabled="!canExport" v-on:click="downloadExcelReport">Excel-export</button>
								</div>
							</div>
							<div class="col-6">
								<div>
									<strong>Kontrol</strong>
								</div>
								<div>
									<button class="btn btn-block btn-dark mt-3" v-if="currentPollIndex === this.polls.length - 1" :disabled="!canNextPoll" v-on:click="end">Afslut{{ changingPoll ? '..' : ''}}</button>
									<button class="btn btn-block btn-dark mt-3" v-else :disabled="!canNextPoll" v-on:click="nextPoll">{{ currentPollIndex !== null ? 'Næste opgave' : 'Start første opgave' }}{{ changingPoll ? '..' : ''}}</button>
								</div>
								<div>
									<button class="btn btn-block btn-dark mt-3" :disabled="!canPreviousPoll" v-on:click="previousPoll">Forrige opgave{{ changingPoll ? '..' : ''}}</button>
								</div>
								<div>
									<button class="btn btn-block btn-dark mt-3" :disabled="!canCloseAnswers" v-on:click="closeAnswers">Luk besvarelse{{ changingAnswers ? '..' : ''}}</button>
								</div>
								<div>
									<button class="btn btn-block btn-dark mt-3" :disabled="!canOpenAnswers" v-on:click="openAnswers">Åben besvarelse{{ changingAnswers ? '..' : ''}}</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
	import {mapGetters} from 'vuex';
	import * as fileDownload from 'js-file-download';

	export default {
		name: 'manager-control-panel-view',
		data() {
			return {
				actuallyMount: false,

				loading: true,
				infoRows: [],
				loadingManagerData: true,
				startedFirstTask: false,

				currentPollIndex: null,

				answersOpen: false,

				changingPoll: false,
				changingAnswers: false,
				changingVisualisation: false,

				completedTasks: null,
				secondsLeft: null,
				answeredClasses: null,
				answeredParticipants: null,
				registeredClasses: null,
				registeredParticipants: null,

				updateContentTimeout: null,

				ending: false,
				ended: false,

				visualisationType: 'chart',
				visualisationEnabled: null,
			}
		},
		mounted() {
			if (!this.actuallyMount) {
				return;
			}

			this.loading = true;

			this.$apiClient.loadData().then((data) => {
				this.$store.commit(MutationTypes.SET_POLLS, data.polls);

				this.$apiClient.loadGameData().then((data) => {
					this.setPollIndexByPollId(data.currentPollId);
					this.answersOpen = data.acceptAnswers;
					this.ended = data.reachedEnd;

					this.$echoClient.listenNewActivePoll(this.onNewActivePoll);
					this.$echoClient.listenAcceptAnswersUpdated(this.onAcceptAnswersUpdated);
					this.$echoClient.listenReachedEnd(this.onReachedEnd);
					this.$echoClient.listenVisualisationUpdated(this.onVisualisationUpdated);

					this.loading = false;

					this.recomputeInfoRows();

					this.updateContent();
				});
			});
		},
		computed: {
			...mapGetters({
				polls: 'getPolls',
			}),
			canExport() {
				return this.currentPollType === 'freetext' || this.currentPollType === 'freetextWord';
			},
			canNextPoll() {
				if (this.changingAnswers || this.changingPoll || this.ending || this.ended) {
					return false;
				}

				if (!this.polls || !this.polls.length) {
					return false;
				}

				if (this.answersOpen) {
					return false;
				}

				return this.currentPollIndex === null || this.currentPollIndex < this.polls.length;
			},
			canPreviousPoll() {
				if (this.changingAnswers || this.changingPoll || this.ending || this.ended) {
					return false;
				}

				if (!this.polls || !this.polls.length) {
					return false;
				}

				if (this.answersOpen) {
					return false;
				}

				return this.currentPollIndex !== null && this.currentPollIndex > 0;
			},
			canCloseAnswers() {
				if (this.changingAnswers || this.changingPoll || this.ending || this.ended) {
					return;
				}

				if (!this.polls || !this.polls.length) {
					return false;
				}

				if (this.currentPollIndex === null) {
					return false;
				}

				return this.answersOpen;
			},
			canOpenAnswers() {
				if (this.changingAnswers || this.changingPoll || this.ending || this.ended) {
					return;
				}

				if (!this.polls || !this.polls.length) {
					return false;
				}

				if (this.currentPollIndex === null) {
					return false;
				}

				return !this.answersOpen;
			},
			currentPoll() {
				if (this.currentPollIndex === null) {
					return false;
				}

				return this.polls[this.currentPollIndex];
			},
			currentPollTitle() {
				if (this.ended) {
					return 'Alle opgaver er afsluttet';
				} else if (this.currentPoll) {
					return `Opgave ${this.currentPollIndex + 1}: ${this.currentPoll.question}`;
				} else {
					return 'Afstemning ikke startet endnu';
				}
			},
			currentPollType() {
				if (this.currentPoll) {
					return this.currentPoll.type;
				}

				return null;
			},
			currentPollTypeText() {
				switch (this.currentPollType) {
					case 'numeric':
						return 'Numerisk';
					case 'freetext':
						return 'Tekst';
					case 'freetextWord':
						return 'Ord';
					default:
							return null;
				}
			},
			canChangeVisualisation() {
				if (this.changingVisualisation) {
					return false;
				}

				return true;
			},
			canToggleVisualisation() {
				if (this.changingVisualisation) {
					return false;
				}

				if (this.currentPollType === 'freetext' || this.currentPollType === 'freetextWord') {
					return false;
				}

				return true;
			}
		},
		beforeMount() {
			let managerCode = this.$apiClient.getHttp().defaults.headers.common['X-Manager-Code'];

			if (!managerCode) {
				this.actuallyMount = false;

				this.$router.push('/manager/');

				return;
			}

			this.actuallyMount = true;
		},
		destroyed() {
			this.$echoClient.stopListeningAll();

			if (this.updateContentTimeout) {
				clearTimeout(this.updateContentTimeout);

				this.updateContentTimeout = null;
			}
		},
		components: {
		},
		methods: {
			toggleVisualisationEnabled() {
				if (!this.canChangeVisualisation) {
					return;
				}

				this.changingVisualisation = true;

				this.$apiClient.setVisualisationEnabled(!this.visualisationEnabled);
			},
			setVisualisationType(visualisationType) {
				if (!this.canChangeVisualisation) {
					return;
				}

				this.changingVisualisation = true;

				this.$apiClient.setVisualisationType(visualisationType);
				this.visualisationType = visualisationType;
			},
			end() {
				if (confirm('Er du sikker på, at du vil afslutte? Denne handling kan ikke fortrydes.')) {
					this.ending = true;

					this.$apiClient.end().then((data) => {
						this.ending = false;
						this.ended = true;
					});
				}
			},
			setPollIndexByPollId(pollId) {
				for (let i = 0, len = this.polls.length; i < len; i++) {
					if (this.polls[i].id === pollId) {
						this.currentPollIndex = i;

						break;
					}
				}
			},
			onNewActivePoll(data) {
				this.$store.commit(MutationTypes.SET_CURRENT_POLL_ID, data.pollId);

				this.setPollIndexByPollId(data.pollId);

				this.changingPoll = false;
				this.answersOpen = false;

				this.updateContent();
			},
			onVisualisationUpdated(data) {
				this.visualisationType = data.visualisationType;
				this.visualisationEnabled = data.visualisationEnabled;

				this.changingVisualisation = false;
			},
			onAcceptAnswersUpdated(data) {
				this.answersOpen = data.acceptAnswers;
				this.changingAnswers = false;

				this.recomputeInfoRows();
			},
			onReachedEnd(data) {
				console.log('data', data);
			},
			openCountryAreas() {
				alert('openCountryAreas');
			},
			openCharts() {
				alert('openCharts');
			},
			openChartsClass() {
				alert('openChartsClass');
			},
			downloadExcelReport() {
				if (!this.currentPoll) {
					return false;
				}

				this.$apiClient.export(this.currentPoll.id).then((url) => {
					window.open(url);
				});
			},
			nextPoll() {
				if (!this.canNextPoll) {
					return;
				}

				if (!confirm('Er du sikker på, at du vil gå til næste opgave?')) {
					return;
				}

				this.changingPoll = true;

				let nextPollIndex;

				if (this.currentPollIndex === null) {
					nextPollIndex = 0;
				} else {
					nextPollIndex = this.currentPollIndex + 1;
				}

				this.$apiClient.setActivePoll(this.polls[nextPollIndex].id);
			},
			previousPoll() {
				if (!this.canPreviousPoll) {
					return;
				}

				if (!confirm('Er du sikker på, at du vil gå til forrige opgave?')) {
					return;
				}

				this.changingPoll = true;

				let previousPollIndex = this.currentPollIndex - 1;

				this.$apiClient.setActivePoll(this.polls[previousPollIndex].id);
			},
			closeAnswers() {
				if (!this.canCloseAnswers) {
					return;
				}

				if (!confirm('Er du sikker på, at du vil lukke muligheden for at svare på opgaven?')) {
					return;
				}

				this.changingAnswers = true;

				this.$apiClient.setAcceptAnswers(false);
			},
			openAnswers() {
				if (!this.canOpenAnswers) {
					return;
				}

				if (!confirm('Er du sikker på, at du vil åbne muligheden for at svare på opgaven?')) {
					return;
				}

				this.changingAnswers = true;

				this.$apiClient.setAcceptAnswers(true);
			},
			updateContent() {
				if (this.updateContentTimeout) {
					clearTimeout(this.updateContentTimeout);

					this.updateContentTimeout = null;
				}

				this.loadingManagerData = true;

				this.$apiClient.loadManagerData().then((data) => {
					this.completedTasks = data.completedTasks || 0
					this.answeredClasses = data.answeredClasses || 0;
					this.answeredParticipants = data.answeredParticipants || 0;
					this.registeredClasses = data.registeredClasses || 0;
					this.registeredParticipants = data.registeredParticipants || 0;

					if (this.visualisationEnabled === null) {
						this.visualisationEnabled = data.visualisationEnabled || false;
						this.visualisationType = data.visualisationType || 'chart';
					}

					this.recomputeInfoRows();

					console.log('manager data', data);

					this.updateContentTimeout = setTimeout(this.updateContent, 5000);

					this.loadingManagerData = false;
				});
			},
			recomputeInfoRows() {
				let status = 'Afstemning ikke startet endnu';

				if (this.currentPoll) {
					status = 'Opgave vises i klasserne';

					if (this.answersOpen) {
						status = 'Opgave og svarmulighederne vises i klasserne';
					}
				}

				this.infoRows = [
					{
						label: 'Tilstand',
						value: status,
					},
					{
						label: 'Antal gennemførte opgaver',
						value: this.currentPollIndex,
					},
					null,
					{
						label: 'Hvor mange klasser har svaret',
						value: this.answeredClasses,
					},
					{
						label: 'Hvor mange deltagere har svaret',
						value: this.answeredParticipants,
					},
					null,
					{
						label: 'Hvor mange  klasser har registreret sig',
						value: this.registeredClasses,
					},
					{
						label: 'Hvor mange deltagere har registreret sig',
						value: this.registeredParticipants,
					},
				];
			},
			start() {
				this.$router.push('/client/register');
			}
		},
	}
</script>

<style lang="scss" scoped>
	.intro-container {
	}

	.current-quiz-row {
		padding: 10px;
		background: #f0f0f0;
		font-weight: bold;
	}

	.logo-container {
		text-align: center;

		margin: 0 auto;

		img {
			max-width: 200px;
		}
	}

	h1 {
		text-align: center;
		line-height: 100%;

		margin-bottom: 0;
	}

	p {
		text-align: center;
		font-size: 10pt;
	}

	.button-container {
		text-align: center;
	}

	.info-value {
		font-weight: bold;
	}

	.current-quiz-row {
		position: relative;
	}

	.current-poll-type{
		padding: 2px 5px;
		background: #00aa00;
		color: white;
	}
</style>
